import { JurisdictionsEnum } from '@libs/backend-common';
export const currencies = [
    {
        label: {
            text: 'USD',
        },
        value: 'USD',
    },
    {
        label: {
            text: 'GEL',
        },
        value: 'GEL',
    },
];
export var FiatCurrencyLabel;
(function (FiatCurrencyLabel) {
    FiatCurrencyLabel["BGEL"] = "B-Lari";
    FiatCurrencyLabel["BUSD"] = "B-Dollar";
})(FiatCurrencyLabel || (FiatCurrencyLabel = {}));
export var BalanceType;
(function (BalanceType) {
    BalanceType["GEL"] = "GEL";
    BalanceType["USD"] = "USD";
    BalanceType["EUR"] = "EUR";
    BalanceType["BGEL"] = "BGEL";
    BalanceType["BUSD"] = "BUSD";
    BalanceType["USDT"] = "USDT";
})(BalanceType || (BalanceType = {}));
export var CurrencyType;
(function (CurrencyType) {
    CurrencyType["BLARI"] = "B-Lari";
    CurrencyType["BDOLLAR"] = "B-Dollar";
    CurrencyType["B-Dollar"] = "B-Dollar";
    CurrencyType["B-Lari"] = "B-Lari";
    CurrencyType["BGEL"] = "BGEL";
    CurrencyType["BUSD"] = "BUSD";
    CurrencyType["EUR"] = "EUR";
    CurrencyType["GEL"] = "GEL";
    CurrencyType["USD"] = "USD";
    CurrencyType["USDT"] = "USDT";
    CurrencyType["BTC"] = "BTC";
    CurrencyType["ETH"] = "ETH";
    CurrencyType["SOL"] = "SOL";
    CurrencyType["LTC"] = "LTC";
    CurrencyType["TRX"] = "TRX";
    CurrencyType["XRP"] = "XRP";
    CurrencyType["DOGE"] = "DOGE";
    CurrencyType["SHIB"] = "SHIB";
    CurrencyType["PEPE"] = "PEPE";
    CurrencyType["ADA"] = "ADA";
    CurrencyType["DOT"] = "DOT";
    CurrencyType["MATIC"] = "MATIC";
    CurrencyType["GMT"] = "GMT";
    CurrencyType["GST"] = "GST";
    CurrencyType["WIF"] = "WIF";
    CurrencyType["OP"] = "OP";
    CurrencyType["BONK"] = "BONK";
    CurrencyType["ARB"] = "ARB";
    CurrencyType["NEAR"] = "NEAR";
    CurrencyType["ATOM"] = "ATOM";
    CurrencyType["LINK"] = "LINK";
    CurrencyType["USDC"] = "USDC";
    CurrencyType["AVAX"] = "AVAX";
    CurrencyType["TON"] = "TON";
})(CurrencyType || (CurrencyType = {}));
export var CurrencySymbol;
(function (CurrencySymbol) {
    CurrencySymbol["GEL"] = "\u20BE";
    CurrencySymbol["BGEL"] = "\u20BE";
    CurrencySymbol["USD"] = "$";
    CurrencySymbol["BUSD"] = "$";
    CurrencySymbol["EUR"] = "\u20AC";
    CurrencySymbol["USDT"] = "\u20AE";
})(CurrencySymbol || (CurrencySymbol = {}));
export var FiatCurrencySymbol;
(function (FiatCurrencySymbol) {
    FiatCurrencySymbol["GEL"] = "\u20BE";
    FiatCurrencySymbol["USD"] = "$";
    FiatCurrencySymbol["EUR"] = "\u20AC";
})(FiatCurrencySymbol || (FiatCurrencySymbol = {}));
export var CurrencyOrigin;
(function (CurrencyOrigin) {
    CurrencyOrigin["FIAT"] = "fiat";
    CurrencyOrigin["CRYPTO"] = "crypto";
})(CurrencyOrigin || (CurrencyOrigin = {}));
export const DEFAULT_CURRENCY_SYMBOLS = {
    [JurisdictionsEnum.EU]: CurrencyType.EUR,
    [JurisdictionsEnum.UA]: CurrencyType.USDT,
    [JurisdictionsEnum.GE]: CurrencyType.USD,
    [JurisdictionsEnum.GLOBAL]: CurrencyType.USD,
};
export const GEL_CURRENCIES = [CurrencyType.BGEL, CurrencyType.GEL];
export const USD_CURRENCIES = [CurrencyType.BUSD, CurrencyType.USD];
export const ALL_FIAT_CURRENCIES = [
    ...GEL_CURRENCIES,
    ...USD_CURRENCIES,
    CurrencyType.EUR,
];
export const ASSET_ALTERNATIVE_CURRENCIES = {
    [CurrencyType.USD]: CurrencyType.BUSD,
    [CurrencyType.BUSD]: CurrencyType.USD,
    [CurrencyType.BGEL]: CurrencyType.GEL,
    [CurrencyType.GEL]: CurrencyType.BGEL,
    [CurrencyType.BLARI]: CurrencyType.BGEL,
    [CurrencyType.BDOLLAR]: CurrencyType.BUSD,
    [CurrencyType.EUR]: undefined,
    [CurrencyType.USDT]: undefined,
    [CurrencyType.BTC]: undefined,
    [CurrencyType.ETH]: undefined,
    [CurrencyType.SOL]: undefined,
    [CurrencyType.LTC]: undefined,
    [CurrencyType.TRX]: undefined,
    [CurrencyType.XRP]: undefined,
    [CurrencyType.DOGE]: undefined,
    [CurrencyType.SHIB]: undefined,
    [CurrencyType.PEPE]: undefined,
    [CurrencyType.ADA]: undefined,
    [CurrencyType.DOT]: undefined,
    [CurrencyType.MATIC]: undefined,
    [CurrencyType.GMT]: undefined,
    [CurrencyType.GST]: undefined,
    [CurrencyType.WIF]: undefined,
    [CurrencyType.OP]: undefined,
    [CurrencyType.BONK]: undefined,
    [CurrencyType.ARB]: undefined,
    [CurrencyType.NEAR]: undefined,
    [CurrencyType.ATOM]: undefined,
    [CurrencyType.LINK]: undefined,
    [CurrencyType.USDC]: undefined,
    [CurrencyType.AVAX]: undefined,
    [CurrencyType.TON]: undefined,
};
export const ASSET_ALTERNATIVE_LABELS = {
    [CurrencyType.USD]: CurrencyType.USD,
    [CurrencyType.BUSD]: CurrencyType.BDOLLAR,
    [CurrencyType.BGEL]: CurrencyType.BLARI,
    [CurrencyType.GEL]: CurrencyType.GEL,
    [CurrencyType.BLARI]: CurrencyType.BLARI,
    [CurrencyType.BDOLLAR]: CurrencyType.BDOLLAR,
    [CurrencyType.EUR]: undefined,
    [CurrencyType.USDT]: undefined,
    [CurrencyType.BTC]: undefined,
    [CurrencyType.ETH]: undefined,
    [CurrencyType.SOL]: undefined,
    [CurrencyType.LTC]: undefined,
    [CurrencyType.TRX]: undefined,
    [CurrencyType.XRP]: undefined,
    [CurrencyType.DOGE]: undefined,
    [CurrencyType.SHIB]: undefined,
    [CurrencyType.PEPE]: undefined,
    [CurrencyType.ADA]: undefined,
    [CurrencyType.DOT]: undefined,
    [CurrencyType.MATIC]: undefined,
    [CurrencyType.GMT]: undefined,
    [CurrencyType.GST]: undefined,
    [CurrencyType.WIF]: undefined,
    [CurrencyType.OP]: undefined,
    [CurrencyType.BONK]: undefined,
    [CurrencyType.ARB]: undefined,
    [CurrencyType.NEAR]: undefined,
    [CurrencyType.ATOM]: undefined,
    [CurrencyType.LINK]: undefined,
    [CurrencyType.USDC]: undefined,
    [CurrencyType.AVAX]: undefined,
    [CurrencyType.TON]: undefined,
};
export const ASSET_ALTERNATIVE_REAL_FIAT_LABELS = {
    [CurrencyType.USD]: CurrencyType.USD,
    [CurrencyType.BUSD]: CurrencyType.USD,
    [CurrencyType.BGEL]: CurrencyType.GEL,
    [CurrencyType.GEL]: CurrencyType.GEL,
    [CurrencyType.BLARI]: CurrencyType.GEL,
    [CurrencyType.BDOLLAR]: CurrencyType.USD,
    [CurrencyType.EUR]: undefined,
    [CurrencyType.USDT]: undefined,
    [CurrencyType.BTC]: undefined,
    [CurrencyType.ETH]: undefined,
    [CurrencyType.SOL]: undefined,
    [CurrencyType.LTC]: undefined,
    [CurrencyType.TRX]: undefined,
    [CurrencyType.XRP]: undefined,
    [CurrencyType.DOGE]: undefined,
    [CurrencyType.SHIB]: undefined,
    [CurrencyType.PEPE]: undefined,
    [CurrencyType.ADA]: undefined,
    [CurrencyType.DOT]: undefined,
    [CurrencyType.MATIC]: undefined,
    [CurrencyType.GMT]: undefined,
    [CurrencyType.GST]: undefined,
    [CurrencyType.WIF]: undefined,
    [CurrencyType.OP]: undefined,
    [CurrencyType.BONK]: undefined,
    [CurrencyType.ARB]: undefined,
    [CurrencyType.NEAR]: undefined,
    [CurrencyType.ATOM]: undefined,
    [CurrencyType.LINK]: undefined,
    [CurrencyType.USDC]: undefined,
    [CurrencyType.AVAX]: undefined,
    [CurrencyType.TON]: undefined,
};
export const ASSET_ALTERNATIVE_ACTIONABLE_CURRENCIES = {
    [CurrencyType.USD]: CurrencyType.BDOLLAR,
    [CurrencyType.BUSD]: CurrencyType.BDOLLAR,
    [CurrencyType.BGEL]: CurrencyType.BLARI,
    [CurrencyType.GEL]: CurrencyType.BLARI,
    [CurrencyType.BLARI]: CurrencyType.BLARI,
    [CurrencyType.BDOLLAR]: CurrencyType.BDOLLAR,
    [CurrencyType.EUR]: undefined,
    [CurrencyType.USDT]: undefined,
    [CurrencyType.BTC]: undefined,
    [CurrencyType.ETH]: undefined,
    [CurrencyType.SOL]: undefined,
    [CurrencyType.LTC]: undefined,
    [CurrencyType.TRX]: undefined,
    [CurrencyType.XRP]: undefined,
    [CurrencyType.DOGE]: undefined,
    [CurrencyType.SHIB]: undefined,
    [CurrencyType.PEPE]: undefined,
    [CurrencyType.ADA]: undefined,
    [CurrencyType.DOT]: undefined,
    [CurrencyType.MATIC]: undefined,
    [CurrencyType.GMT]: undefined,
    [CurrencyType.GST]: undefined,
    [CurrencyType.WIF]: undefined,
    [CurrencyType.OP]: undefined,
    [CurrencyType.BONK]: undefined,
    [CurrencyType.ARB]: undefined,
    [CurrencyType.NEAR]: undefined,
    [CurrencyType.ATOM]: undefined,
    [CurrencyType.LINK]: undefined,
    [CurrencyType.USDC]: undefined,
    [CurrencyType.AVAX]: undefined,
};
//# sourceMappingURL=currency.js.map